<template>
	<div class="relative w-full min-h-[40px]">
		<div v-if="!isButtonVisible" class="absolute inset-0">
			<div class="w-full h-full border border-ihh-gray/40 rounded flex items-center justify-center bg-white">
				<Spinner :small="true" class="w-4 h-4" color="border-t-ihh-salmon" />
			</div>
		</div>
		<button
			@click="setupBraintreeVenmo"
			class="w-full min-h-[40px] bg-venmo-blue hover:bg-venmo-blue-hover border border-ihh-gray/40 rounded flex items-center justify-center transition-colors"
			:class="{ invisible: !isButtonVisible }"
		>
			<img src="/images/Venmo_Logo_White.png" alt="Venmo" class="max-h-[13px]" />
		</button>

		<!-- <div v-if="showModal" id="expressCheckoutDetails" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
			<div class="bg-white w-full md:max-w-xl md:h-auto p-6 rounded max-h-[80vh] overflow-auto">
				<div class="flex justify-end mb-2">
					<button @click="showModal = false" class="text-ihh-midnight-gray">
						<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
						</svg>
					</button>
				</div>
				<ShippingAndBilling />

				<ExpressCheckoutSummary />

				<div class="w-full flex justify-center my-6">
					<button
						@click="setupBraintreeVenmo"
						class="w-full max-w-[250px] min-h-[40px] bg-venmo-blue hover:bg-venmo-blue-hover border border-ihh-gray/40 rounded flex items-center justify-center transition-colors"
						:class="{ invisible: !isButtonVisible }"
					>
						<img src="/images/Venmo_Logo_White.png" alt="Venmo" class="max-h-[13px]" />
					</button>
				</div>
			</div>
		</div> -->
	</div>

	<PaymentProcessingSpinner :processing="paymentProcessing" message="Processing payment..." />
</template>

<script>
import axios from 'axios'
import helpers from '../../helpers/checkout.js'
import Swal from 'sweetalert2'
import Braintree from '../../helpers/braintree.js'

import ShippingAndBilling from './shipping-and-billing.vue'
import ExpressCheckoutSummary from './express-checkout-summary.vue'
import PaymentProcessingSpinner from './payment-processing-spinner.vue'

export default {
	name: 'VenmoButton',
	inject: ['store', 'checkout'],

	components: {
		ShippingAndBilling,
		ExpressCheckoutSummary,
		PaymentProcessingSpinner,
	},

	props: {
		isVenmoCheckout: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			clientToken: null,
			clientInstance: null,
			dataCollectorInstance: null,
			venmoInstance: null,
			deviceData: null,
			isButtonVisible: false,
			showModal: false,
			paymentProcessing: false,
			processing: false,
		}
	},

	async mounted() {
		// Check for mobile browser
		if (this.isMobileBrowser()) {
			console.log('Mobile browser detected, hiding Venmo button')
			this.$emit('updateShowVenmo', false)
			return
		}

		// Only hide on Safari desktop - Venmo should work on most browsers
		if (this.isSafari()) {
			console.log('Safari desktop detected, hiding Venmo button')
			this.$emit('updateShowVenmo', false)
			return
		}

		try {
			await this.fetchClientToken()
			// Set button visible after token is fetched
			this.isButtonVisible = true
		} catch (error) {
			console.error('Error in Venmo button initialization:', error)
			this.$emit('updateShowVenmo', false)
		}
	},

	methods: {
		isMobileBrowser() {
			// Check if the browser is a mobile browser
			const userAgent = navigator.userAgent.toLowerCase()
			return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile/i.test(userAgent)
		},

		isSafari() {
			// More accurate Safari detection
			const userAgent = navigator.userAgent.toLowerCase()
			// Many browsers include 'safari' in their UA string, so we need to be more specific
			// Safari on iOS often has 'mobile' and 'safari' but not 'chrome'
			const isSafariMac = userAgent.includes('safari') && !userAgent.includes('chrome') && userAgent.includes('macintosh')
			const isSafariIOS = userAgent.includes('safari') && !userAgent.includes('chrome') && userAgent.includes('iphone')

			// For testing on mobile, let's disable Safari detection
			if (window.innerWidth < 768) {
				return false
			}

			return isSafariMac || isSafariIOS
		},

		async fetchClientToken() {
			try {
				console.log('Fetching the client token for Venmo...')
				const response = await axios.get(`${this.store.api}/controllers/braintree/clientToken`)

				if (!response.data.success) {
					console.error('Failed to fetch client token:', response.data.message)
					throw new Error(response.data.message || 'Failed to fetch client token')
				}

				this.clientToken = response.data.token
				return response.data.token
			} catch (error) {
				console.error('Error fetching client token:', error)
				throw error
			}
		},

		async setupBraintreeVenmo() {
			if (this.processing) return
			this.processing = true
			const initVenmo = await helpers.initializeVenmo({ clientToken: this.clientToken, amount: this.store?.cart?.total })
			if (!initVenmo?.success) {
				this.processing = false
				if (initVenmo?.error?.code === 'VENMO_DESKTOP_CANCELED') {
					console.log('User canceled payment flow')
					return
				}
				console.error('Error initializing Venmo checkout:', initVenmo.message)
				return Swal.fire({
					icon: 'error',
					title: 'Error',
					text: 'Error initializing Venmo checkout',
					confirmButtonText: 'OK',
				})
			}
			const clientInstance = initVenmo.clientInstance
			const deviceData = await Braintree.dataCollector(clientInstance)
			this.deviceData = deviceData
			this.paymentProcessing = true
			await this.completeOrder(initVenmo.nonce)
			this.processing = false
		},

		async completeOrder(nonce) {
			try {
				// const updateShipping = await helpers.updateShippingAddress({
				// 	address: this.checkout.shipping.shippingAddress,
				// 	bcCartId: this.store?.cart?.bcId,
				// 	consignmentId: this.checkout.shipping.consignmentId,
				// })
				// if (!updateShipping?.success) {
				// 	this.paymentProcessing = false
				// 	return Swal.fire('Error', 'Failed to update shipping address', 'error')
				// }

				const bcOrderResponse = await helpers.placeOrder({ paymentMethod: 'apm' })

				const bcOrderId = bcOrderResponse?.bcOrderId
				if (!bcOrderId) {
					this.paymentProcessing = false
					this.processing = false
					throw new Error('Failed to create BigCommerce order.')
				}

				// const orderData = {
				// 	deviceData: this.deviceData,
				// 	nonce,
				// 	amount: this.grandTotal,
				// 	bcOrderId,
				// }

				// console.log('Order Data:', orderData)

				// Process payment with Braintree
				const paymentResponse = await helpers.processBraintreePayment({
					nonce,
					amount: this.grandTotal,
					bcOrderId,
					deviceData: this.deviceData,
				})

				if (!paymentResponse?.success) {
					this.paymentProcessing = false
					this.processing = false
					throw new Error(paymentResponse?.message || 'Payment processing failed.')
				}

				console.log('Payment successful:', paymentResponse.data)
				const { redirectUrl } = await helpers.handleCheckoutSuccess(bcOrderId, paymentResponse, ['submitted_for_settlement', 'settling', 'settled'])

				this.paymentProcessing = false
				this.processing = false

				this.$router.push(redirectUrl)
			} catch (error) {
				console.error('Error completing order:', error)
				this.paymentProcessing = false
				this.processing = false
				await Swal.fire({
					icon: 'error',
					title: 'Order Error',
					text: 'There was an error processing your order. Please try again.',
				})
			}
		},
	},

	computed: {
		isVenmoEmpty() {
			return !this.isButtonVisible
		},
		grandTotal() {
			return this.checkout.remainingBalance
		},
	},

	beforeDestroy() {
		if (this.venmoInstance) {
			this.venmoInstance.teardown()
		}
		if (this.dataCollectorInstance) {
			this.dataCollectorInstance.teardown()
		}
	},
}
</script>

<style scoped></style>
